
















































import { Component, Vue, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencyModule } from '@/store/modules/agency';
import JobDto from '@/models/Jobs/JobDto';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import UpdateRichTextRequest from '@/models/Shared/UpdateRichTextRequest';

@Component({
    name: 'JobSummaryEdit'
})
export default class JobSummaryEdit extends GiganautVueDialog {

  entity: JobDto = new JobDto();
  public editorKey = 0;
  public editorReady = false;

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.editorReady = false;
      this.entity = JSON.parse(JSON.stringify(JobDetailsModule.currentJob));
      this.editorKey++;
      this.$nextTick(() => {
        this.editorReady = true;
      });
    } else {
      this.editorReady = false;
    }
  }

  get loading() {
    return JobDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    
    const request = new UpdateRichTextRequest()
    request.updatedAt = this.entity.updatedAt;
    request.richText = this.entity.summary;

    await JobDetailsModule.editJobSummary(request)
    this.dialog = false;
  }
}
